/* eslint-disable no-unreachable */
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Delete } from "@material-ui/icons";
import { ethers } from "ethers";
import { getSigner } from "helper/network";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { stakingService } from "services/stakingService";

import { abi as StakeFeeAbi } from "../../contracts/StakeFee.sol/StakeFee.json";
import detectAndSwitchChain from "helper/switchChain";
import { chainOptions } from "const";

// const contractAddress = process.env.REACT_APP_STAKE_FEE_ADDRESS;

const getStakeFeeAddress = async () => {
  if (!window.ethereum) return;
  const { ethereum } = window;
  const provider = new ethers.providers.Web3Provider(ethereum);
  const { chainId } = await provider.getNetwork();
  return chainOptions().find((c) => +c.value === +chainId)?.config
    ?.stakeFeeAddress;
};

const useStyles = makeStyles({
  table: {
    minWidth: 400,
  },
  textField: {
    width: 80,
    marginRight: 10,
  },
  addButton: {
    marginBottom: 10,
  },
});

const FeeType = {
  stake: 0,
  withdraw: 1,
  claim: 2,
  addBooster: 3,
  removeBooster: 4,
};

const compareArrays = (a, b) =>
  a.length === b.length && a.every((element, index) => element === b[index]);

const EditableTable = () => {
  const classes = useStyles();

  const [specialFees, setSpecialFees] = useState([]);
  const [pools, setPools] = useState([]);
  const [pool, setPool] = useState(null);
  const [loading, setLoading] = useState(false);
  const [collectionAddresses, setCollectionAddresses] = useState([]);
  const [gStakeFeeAddress, setgStakeFeeAddress] = useState("");

  const handleAddCollection = () => {
    if (pool === null) {
      toast.error("Please select pool first");
      return;
    }
    setSpecialFees([
      ...specialFees,
      {
        collectionAddress: "",
        collectionName: "",
        collectionLink: "",
        fee: {
          stake: 0,
          withdraw: 0,
          claim: 0,
          addBooster: 0,
          removeBooster: 0,
        },
      },
    ]);
  };

  const handleRemoveCollection = (index) => {
    // check if all fee is 0, if not, show warning
    const fee = specialFees[index].fee;
    if (Object.values(fee).some((value) => value !== 0)) {
      toast.error("Please set all fee to 0 before remove collection");
      return;
    }

    const newCollections = [...specialFees];
    newCollections.splice(index, 1);
    setSpecialFees(newCollections);
  };

  const handleAddressChange = (event, index) => {
    const newCollections = [...specialFees];
    newCollections[index].collectionAddress = event.target.value;
    setSpecialFees(newCollections);
  };

  const handleNameChange = (event, index) => {
    const newCollections = [...specialFees];
    newCollections[index].collectionName = event.target.value;
    setSpecialFees(newCollections);
  };

  const handleLinkChange = (event, index) => {
    const newCollections = [...specialFees];
    newCollections[index].collectionLink = event.target.value;
    setSpecialFees(newCollections);
  };

  const handlePriceChange = (event, collectionIndex, priceType) => {
    const newSpecialFees = [...specialFees];
    newSpecialFees[collectionIndex].fee[priceType] = event.target.value;
    setSpecialFees(newSpecialFees);
  };

  const handleSubmit = async (collectionAddress, key) => {
    if (!pool.chainId) return;
    await detectAndSwitchChain(pool.chainId);
    const collectionFee = specialFees.find(
      (fee) => fee.collectionAddress === collectionAddress
    );
    // check if duplicate collection
    const duplicateCollection = specialFees.filter(
      (fee) =>
        fee.collectionAddress.toLowerCase() === collectionAddress.toLowerCase()
    );
    if (duplicateCollection.length > 1) {
      toast.error("Duplicate collection");
      return;
    }

    setLoading(true);
    try {
      const signer = await getSigner();
      const stakeFeeAddress = await getStakeFeeAddress();
      const contract = new ethers.Contract(
        stakeFeeAddress,
        StakeFeeAbi,
        signer
      );
      await updateListAddressOnContract(contract);

      // update special fee on contract
      const value = ethers.utils.parseEther(collectionFee.fee[key].toString());
      const tx2 = await contract.setSpecialFee(
        pool.address,
        collectionAddress,
        FeeType[key],
        value
      );
      await tx2.wait();

      stakingService.updateSpecialFees(pool._id, specialFees);
      toast.success("Update special fees successfully");
    } catch (e) {
      console.log(e.toString().includes("Ownable"), "ii");
      if (e.toString().includes("Ownable")) {
        toast.error("You are not owner of this contract");
      } else {
        toast.error("Update special fees failed");
      }
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  async function updateListAddressOnContract(contract) {
    if (!pool.chainId) return;
    await detectAndSwitchChain(pool.chainId);
    const newCollectionAddresses = specialFees
      .map((fee) => fee.collectionAddress.toLowerCase())
      .filter((address) => address !== "");
    const needUpdate = !compareArrays(
      newCollectionAddresses,
      collectionAddresses
    );
    console.log("needUpdate", needUpdate);

    if (needUpdate) {
      const tx1 = await contract.setCollections(
        pool.address,
        newCollectionAddresses
      );
      await tx1.wait();
      setCollectionAddresses([...newCollectionAddresses]);
    }
  }

  async function fetchStakings() {
    try {
      const { data } = await stakingService.list({
        search: "",
        page: 0,
        size: 1000,
      });
      setPools(data.items.filter((pool) => pool.canBoost));
    } catch (e) {
      console.log(e);
    }
  }

  async function getstakefeeaddress() {
    const stakeFeeAddress = await getStakeFeeAddress();
    setgStakeFeeAddress(stakeFeeAddress);
  }

  useEffect(() => {
    fetchStakings();
    getstakefeeaddress();
  }, []);

  useEffect(() => {
    if (pool) {
      setSpecialFees([...pool.specialFees]);
      setCollectionAddresses(
        pool.specialFees
          .map((fee) => fee.collectionAddress?.toLowerCase())
          .filter((address) => address !== "")
      );
    }
  }, [pool]);

  return (
    <div>
      <FormControl style={{ width: "500px" }}>
        <InputLabel id="pool-label">Pool</InputLabel>
        <Select
          labelId="pool-label"
          id="pool"
          value={pool}
          label="Pool"
          onChange={(e) => setPool(e.target.value)}
        >
          {pools.map((pool) => (
            <MenuItem key={pool.address} value={pool}>
              {pool.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <ul>
        <li>Pool address: {pool?.address}</li>
        <li>Price address: {gStakeFeeAddress}</li>
      </ul>

      <div style={{ marginTop: "20px" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddCollection}
          className={classes.addButton}
          disabled={pool === null}
        >
          Add collection to check holder
        </Button>
      </div>

      <h5> If value is 0, use default fee</h5>

      <TableContainer>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Collection</TableCell>
              <TableCell>Stake</TableCell>
              <TableCell>Withdraw</TableCell>
              <TableCell>Claim</TableCell>
              <TableCell>Add booster</TableCell>
              <TableCell>Remove booster</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {specialFees.map((fee, index) => (
              <React.Fragment key={index}>
                <TableRow>
                  <TableCell>
                    <Button
                      justIcon
                      round
                      simple
                      color="danger"
                      className="edit"
                      onClick={() => handleRemoveCollection(index)}
                      disabled={loading}
                    >
                      <Delete color="danger" />
                    </Button>
                  </TableCell>
                  <TableCell>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <TextField
                        margin="dense"
                        label="Collection address"
                        value={fee.collectionAddress}
                        onChange={(event) => handleAddressChange(event, index)}
                        variant="outlined"
                        size="small"
                      />

                      <TextField
                        margin="dense"
                        label="Collection name"
                        value={fee.collectionName || ""}
                        onChange={(event) => handleNameChange(event, index)}
                        variant="outlined"
                        size="small"
                      />

                      <TextField
                        margin="dense"
                        label="Collection link"
                        value={fee.collectionLink || ""}
                        onChange={(event) => handleLinkChange(event, index)}
                        variant="outlined"
                        size="small"
                      />
                    </div>
                  </TableCell>

                  {Object.keys(FeeType).map((key) => (
                    <TableCell key={key}>
                      <TextField
                        value={fee.fee[key]}
                        onChange={(event) =>
                          handlePriceChange(event, index, key)
                        }
                        variant="outlined"
                        size="small"
                        className={classes.textField}
                        placeholder="0 = default"
                      />

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleSubmit(fee.collectionAddress, key)}
                        disabled={loading}
                        size="small"
                      >
                        Submit
                      </Button>
                    </TableCell>
                  ))}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default EditableTable;
